import http from 'utils/http';
import { getInteractionLogUrl, getInteractionsLogsUrl } from './apiUrls';
import { InteractionLogResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getInteractionsLogs(
  workspaceId: string,
  agentId: string,
  params?: Record<string, any>
): Promise<{ data: InteractionLogResponse[]; meta: MetaApiResponse }> {
  return http.get(getInteractionsLogsUrl(workspaceId, agentId), params);
}

export function getInteractionLog(workspaceId: string, agentId: string, id: string): Promise<InteractionLogResponse> {
  return http.get(getInteractionLogUrl(workspaceId, agentId, Number(id)));
}

export function deleteInteractionLog(
  workspaceId: string,
  agentId: string,
  id: number
): Promise<{ meta: { message: string } }> {
  return http.delete(getInteractionLogUrl(workspaceId, agentId, id));
}
